// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block_x3{
    height: 1.5rem!important;
}
.block_x5{
    height: 2.3rem!important;
}
.block_x50{
    height: 3.1rem!important;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Wheel/global_stylesSimpleRoulete.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B","sourcesContent":[".block_x3{\n    height: 1.5rem!important;\n}\n.block_x5{\n    height: 2.3rem!important;\n}\n.block_x50{\n    height: 3.1rem!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
